import React from 'react'
import {
    Button,
    Form,
    Grid,
    Header,
    Icon,
    Input,
    Message,
    Popup,
    Dropdown,
    Image,
    Segment,
    Dimmer,
    Loader, Progress
} from "semantic-ui-react";


function Quiz(
    {
        handleSubmit,
        question,
        handleAnswerChange,
        answer,
        attempts,
        currentQuestionNum,
        assignmentLength,
        incrementQuestion,
        decrementQuestion,
        handleRedirect,
        result,
        showHint,
        toggleHint,
        gradeColor,
        handleAssignmentChange,
        assignmentNum,
        assignmentOptions,
        imageURL,
        loading,
        progress,
        progressText,
        assignmentChosen,
        currentAssignmentCompletion,
        tmpCheckMark,
        loadingMessage,
        userIsLoggedIn
    }) {


    return (
        <>
            {

                <div className='quizButton'>
                    <br/>

                    <Grid className='center aligned'>

                        <Grid.Row>
                            <Header as='h1'>Translation Practice</Header>
                        </Grid.Row>
                        <Grid.Row>
                            <Message color='blue'>
                                <p style={{color: 'black'}}>
                                    Directions:
                                    <br/>
                                    Translate the word or sentence below into Samoan.
                                    <br/>
                                    Click on the green check button to check your answer.
                                    <br/>
                                    After 5 tries, you can click on the "I give up" button to see the answer.
                                    <br/>
                                    Use the dropdown below to choose an assignment to work on.
                                    <br/><br/>
                                    Completion Guide:<br/>
                                    ⭑ => 25 %<br/>
                                    ⭑⭑ => 50 %<br/>
                                    ⭑⭑⭑ => 75 %<br/>
                                    ⭑⭑⭑⭑ => 100 %<br/>
                                </p>
                            </Message>
                        </Grid.Row>

                        {
                            loading ?
                                <Grid.Row>
                                    <Progress indicating progress percent={progress} style={{width: 400}}>
                                        {progressText}

                                    </Progress>

                                </Grid.Row>
                                :
                                loadingMessage ?
                                    <Grid.Row>
                                        <Progress indicating progress percent={progress} style={{width: 400}}>
                                            {loadingMessage}

                                        </Progress>

                                    </Grid.Row>                                    :
                                    <Grid.Row>
                                        <Dropdown
                                            onChange={handleAssignmentChange}
                                            options={assignmentOptions}
                                            placeholder='Choose an assignment'
                                            selection
                                            value={assignmentNum}
                                        />
                                    </Grid.Row>
                        }
                        {
                            assignmentChosen ?
                                <>
                                    <Grid.Row>

                                        {
                                            result.report ?
                                                <Message size='small' color={gradeColor}>{result.report}</Message>
                                                :
                                                null
                                        }
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Message color='blue'>
                                            {
                                                userIsLoggedIn ?


                                                    currentAssignmentCompletion[currentQuestionNum - 1] || tmpCheckMark ?
                                                        <Icon color='green' name='check circle'/>

                                                        :
                                                        <Icon name='circle outline'/>
                                                    :
                                                    null

                                            }
                                            <Grid className='center aligned'>
                                                <Grid.Row columns={2}>
                                                    <Grid.Column>
                                                        <Image src={imageURL} size='small'/>
                                                    </Grid.Column>
                                                    <Grid.Column>
                                                        <Popup
                                                            content='Samoan Dictionary'
                                                            trigger={
                                                                <Button color='orange' size='medium'
                                                                        style={{paddingRight: 10, marginRight: -5}}
                                                                        floated='right'
                                                                        onClick={handleRedirect}>
                                                                    Dictionary
                                                                    <Icon name='book' style={{marginLeft: 10}}/>
                                                                </Button>
                                                            }
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>


                                            <br/>
                                            <br/>
                                            <Form>
                                                <Header>Translate: {question}</Header>
                                                <br/>
                                                <Form.Group>
                                                    <Input
                                                        placeholder='Type your answer here...'
                                                        type='text'
                                                        style={{width: 500}}
                                                        onChange={handleAnswerChange}
                                                        value={answer}
                                                        placeholer='Type your answer here...'
                                                    />
                                                    <Button onClick={handleSubmit} color='green'
                                                            style={{marginLeft: 10, paddingRight: 10}}>
                                                        <Icon name='check'/>
                                                    </Button>
                                                </Form.Group>

                                                {attempts >= 5 ? <Button onClick={toggleHint}>I give up</Button> : null}

                                                <Button onClick={incrementQuestion} floated='right' icon>
                                                    <Icon name='arrow right'/>
                                                </Button>
                                                <Header floated='right' as='h4' style={{
                                                    marginTop: 5,
                                                    marginLeft: 10,
                                                    marginRight: 10
                                                }}>{currentQuestionNum}/{assignmentLength}</Header>
                                                <Button onClick={decrementQuestion} floated='right' icon>
                                                    <Icon name='arrow left'/>
                                                </Button>
                                                <br/>
                                                {
                                                    showHint ?
                                                        <Message
                                                            style={{marginTop: 30}}>Answer: {result.closestAnswer}</Message>
                                                        :
                                                        null
                                                }
                                            </Form>

                                        </Message>
                                    </Grid.Row>
                                </>
                                :
                                null
                        }


                    </Grid>
                </div>
            }
        </>


    )
}

export default Quiz
